import { z } from 'zod';

import { backendEndpoints } from '$/services/endpoints';
import { fetcher } from '$/services/fetcher';
import {
  GeneralBackendResponseObjectSchema,
  GeneralBackendResponseSchema,
} from '$/services/mapper/authentication';
import {
  AdminOptionSchema,
  PublicAdminOption,
} from '$/services/usecases/adminOptions/mapper';
import { validateToken } from '$/services/usecases/authentication';

const GetAdminOptionsSchema = z.object({
  ...GeneralBackendResponseSchema,
  payload: AdminOptionSchema.array(),
});

export const getAdminOptions = async (type: PublicAdminOption['type']) => {
  await validateToken();
  return await fetcher(`${backendEndpoints.ADMIN_OPTIONS_URL}/${type}`, {
    method: 'GET',
    parser: (data) => GetAdminOptionsSchema.parse(data),
    includeCredentials: true,
  });
};

export const upsertAdminOption = async (option: PublicAdminOption) => {
  await validateToken();
  return await fetcher(backendEndpoints.ADMIN_OPTIONS_URL, {
    method: 'PUT',
    body: option,
    includeCredentials: true,
    parser: (data) => GeneralBackendResponseObjectSchema.parse(data),
  });
};
